import {Box, chakra, Container, SimpleGrid, Stack, Text, useColorModeValue, VisuallyHidden, Image, Link} from "@chakra-ui/react";
import {FaFacebook, FaInstagram, FaTwitter, FaYoutube} from "react-icons/fa";
import React, {ReactNode} from "react";

export function Footer() {
    return (
        <Box
            // bg={useColorModeValue('gray.50', 'gray.900')}
            color={useColorModeValue('gray.700', 'gray.200')}
            bg={"white"} /*px={4}*/ boxShadow={"sm"}
            mt="2%"
            borderTopWidth={1}
            borderStyle={'solid'}
        >

            <Container as={Stack} maxW={'6xl'} py={10}>
                <SimpleGrid
                    py={5}
                    columns={{ base: 1, md: 3 }}
                    spacing={8}
                >
                    <Stack align={{ base: 'center', md: 'flex-start' }} textAlign={{ base: 'center', md: 'left' }}>
                        <ListHeader>Svaz vinařů České republiky, z.s.</ListHeader>
                        <Box as="div">Žižkovská 1230</Box>
                        <Box as="div">691 02 Velké Bílovice</Box>
                        <Box as="div">IČO: 48847488</Box>
                        <Box as="div">DIČ: CZ48847488</Box>
                    </Stack>

                    <Stack align={{ base: 'center', md: 'flex-start' }} textAlign={{ base: 'center', md: 'left' }}>
                        <ListHeader>
                            Ing. Martin Půček
                            <Text size={'sm'} fontWeight={'normal'} color={'gray'}>
                                {"Šéfredaktor"}
                            </Text>
                        </ListHeader>

                        <Box as="a" href={'tel: +420 606 743 231'}>
                            +420 606 743 231
                        </Box>

                        <Box as="a" href={'mailto:martin.pucek@svcr.cz'}>
                            martin.pucek@svcr.cz
                        </Box>

                        <ListHeader>
                            Markéta Nováková
                            <Text size={'xs'} fontWeight={'normal'} color={'gray'}>
                                {"Asistentka redakce, předplatné, fakturace"}
                            </Text>
                        </ListHeader>

                        <Box as="a" href={'tel: +420 602 470 345'}>
                            +420 602 470 345
                        </Box>

                        <Box as="a" href={'mailto:marketa.novakova@svcr.cz'}>
                            marketa.novakova@svcr.cz
                        </Box>

                        <ListHeader>
                            Jarek Konečný
                            <Text size={'sm'} fontWeight={'normal'} color={'gray'}>
                                {"Inzerce"}
                            </Text>
                        </ListHeader>

                        <Box as="a" href={'tel: +420 702 143 468'}>
                            +420 702 143 468
                        </Box>

                        <Box as="a" href={'mailto: jarek.konecny@svcr.cz'}>
                            jarek.konecny@svcr.cz
                        </Box>
                    </Stack>

                    <Stack align={{ base: 'center', md: 'flex-start' }} textAlign={{ base: 'center', md: 'left' }}>
                        <ListHeader>Telefonní linka pro fakturaci a předplatné</ListHeader>
                        <Box as="a" href={'tel: +420 602 470 345'}>
                            +420 602 470 345 (Po-Pá 9:00-16:00)
                        </Box>

                        <Box as="div" my={2}>
                            <ListHeader>Telefonní linka pro podporu</ListHeader>
                            <Box as="a" href={'tel: +420 606 743 231'}>
                                +420 606 743 231 (Ing. Martin Půček)
                            </Box>
                        </Box>
                    </Stack>
                </SimpleGrid>
            </Container>

            <Box
                borderColor={useColorModeValue('gray.200', 'gray.700')}>
                <Container
                    as={Stack}
                    maxW={'6xl'}
                    py={4}
                    direction={{ base: 'column', md: 'row' }}
                    spacing={4}
                    justify={{ md: 'space-between' }}
                    align={{ base:"center",  md: 'center', sm: "center"}}>
                    <Link href={"https://www.svcr.cz/"}>
                        <Image
                            py={2}
                            src={'/logo_svz.jpg'}
                            alt={'Svaz vinařů Logo'}
                            w={'250px'}
                            objectFit={'contain'}
                        />

                    </Link>
                    <Link href={"https://www.jmk.cz/"}>
                        <Image
                            py={2}
                            src={'/images/jmk.png'}
                            alt={'Svaz vinařů Logo'}
                            w={'250px'}
                            objectFit={'contain'}
                        />
                    </Link>
                    <Link href={"https://www.vinazmoravyvinazcech.cz/en"}>
                        <Image
                            py={2}
                            src={'/images/podpora_vf.png'}
                            alt={'Podpora VF'}
                            w={'250px'}
                            objectFit={'contain'}
                        />
                    </Link>
                    <Stack direction={'row'} spacing={6}>
                        <SocialButton label={'Facebook'} href={'https://www.facebook.com/svazvinaru'}>
                            <FaFacebook />
                        </SocialButton>
                        <SocialButton label={'Instagram'} href={'https://www.instagram.com/svazvinaru/'}>
                            <FaInstagram />
                        </SocialButton>
                        <SocialButton label={'Youtube'} href={'https://www.youtube.com/c/svazvinaruceskerepubliky'}>
                            <FaYoutube />
                        </SocialButton>
                    </Stack>
                </Container>
            </Box>
        </Box>
    )
}

const ListHeader = ({ children }: { children: ReactNode }) => {
    return (
        <Text fontWeight={'500'} fontSize={'lg'} mt={4} >
            {children}
        </Text>
    )
}

const SocialButton = ({
                          children,
                          label,
                          href,
                      }: {
    children: ReactNode,
    label: string,
    href: string
}) => {
    return (
        <chakra.button
            bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
            rounded={'full'}
            w={8}
            h={8}
            cursor={'pointer'}
            as={'a'}
            href={href}
            display={'inline-flex'}
            alignItems={'center'}
            justifyContent={'center'}
            transition={'background 0.3s ease'}
            _hover={{
                bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
            }}>
            <VisuallyHidden>{label}</VisuallyHidden>
            {children}
        </chakra.button>
    )
}

